import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'

import ContextProvider from '~/provider/ContextProvider'

import { GlobalStyle } from '~/utils/styles'
import Navigation from '~/components/Navigation'
import Footer from '~/components/Footer'

const Layout = ({ location, children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ContextProvider>
      <GlobalStyle />
      {!location.pathname.match(/^\/cart\/remove/) ? <Navigation siteTitle={data.site.siteMetadata.title} /> : ''}
      {children}
      {!location.pathname.match(/^\/cart\/remove/) ? <Footer /> : ''}
    </ContextProvider>
  )
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout